import APIService from '../../services/api'

import { GET_EXHIBITION_ADDRESS, ADD_RESULT_MAP, ERROR_API } from './constants'

import { getMapDataFromExhibition } from './resultmap.helper'

export const actionsMap = {
  [GET_EXHIBITION_ADDRESS] ({commit, state},
    { id }) {
    let filters = [
      {
        property: 'id_exhibition',
        matchType: 'eq',
        value: id
      }
    ]
    APIService.searchExhibitionAddress({
      filters: filters,
      transform: true,
      satisfy: 'all',
      columns: 'id_exhibition,exhibition_title,city,begin_year,begin_date,section_x,section_y'
    }).then(json => {
      commit(ADD_RESULT_MAP, {
        result: getMapDataFromExhibition(json.visu_exhibition_address)
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsMap



// WEBPACK FOOTER //
// ./src/store/search/actions.map.js